export const GET_FAQ_REQUEST  = 'GET_FAQ_REQUEST';
export const GET_FAQ_SUCCESS  = 'GET_FAQ_SUCCESS';
export const GET_FAQ_FAIL  = 'GET_FAQ_FAIL';